import useStateMachineWrapper from "./useStateMachineWrapper";

const getApplicablePromo = (
    session,
    { speed = null, pods = null, groupId = null } = {}
) => {
    if (!session.availableServices) return null;
    
    const parseInstruction = input => {
        const [operatorRaw, numRaw] = input.split(' ', 2);
        const operator = operatorRaw.trim() === '===' ? '==' : operatorRaw.trim();
        return { operator, num: numRaw.trim() };
    };

    const valueMeetsRequirements = (value, instruction) => {
        const { operator, num } = parseInstruction(instruction);
        const v = parseFloat(value), n = parseFloat(num);
        switch (operator) {
            case '>=': return v >= n;
            case '<=': return v <= n;
            case '==': return v ==  n;
            default:   return false;
        }
    };
    //console.log('getapp promo');
    let applicablePromos = [];

    for (const promo of session?.availableServices?.promos || []) {
        //console.log('getapp promo looping conditions');
        const promoGroupId = promo.group?.id ?? null;
        //console.log(promoGroupId);
        if (promoGroupId !== null && parseInt(promoGroupId) !== 1 && parseInt(promoGroupId) !== parseInt(groupId)) {
            //console.log('group');
            continue;
        }
        
        if (!promo.conditions || !Object.keys(promo.conditions).length) {
            //console.log('conditions');
            continue;
        }
        
        if (promo.conditions.speed) {
            const testSpeed = speed != null ? speed : session.speed;
            const passed = valueMeetsRequirements(testSpeed, promo.conditions.speed);
            if (!passed) {
                //console.log('speed');
                continue;
            }
        }

        if (promo.conditions.pods) {
            const podCount = session.page === 'choose-internet' ? 0 : (pods != null ? pods : session.pods);
            const passed = valueMeetsRequirements(podCount, promo.conditions.pods);
            if (!passed) {
                //console.log('pods');
                continue;
            }
        }

        applicablePromos.push(promo);
    }
    //console.log('getapp promo after conditions');
    if (!applicablePromos.length) return null;
    if (applicablePromos.length === 1) {
        const solo = applicablePromos[0];
        //console.log('only 1',{...solo, allPromos: [solo]});
        return {
            ...solo,
            allPromos: [solo]
        };
    }
    //console.log('getapp promo more than 1');
    const agg = {
        id: '',
        description: '',
        discount: { internet: 0, pods_included: 0, percentage: 0 },
        conditions: { speed: '', pods: '' },
        extras: { wifi_terms: '' },
        display: true,
        group: { id: groupId, name: '', priority: '' },
        allPromos: applicablePromos
    };

    for (const promo of applicablePromos) {
        if (agg.id) {
            agg.id += ',';
            agg.description += ' + ';
        }
        agg.id += promo.id;
        agg.description += promo.description;

        agg.discount.internet     += parseFloat(promo.discount.internet);
        agg.discount.pods_included+= parseFloat(promo.discount.pods_included);
        agg.discount.percentage   += parseFloat(promo.discount.percentage || 0);

        if (!agg.conditions.speed) agg.conditions.speed = promo.conditions.speed;
        if (!agg.conditions.pods ) agg.conditions.pods  = promo.conditions.pods;

        if (!agg.extras.wifi_terms && promo.extras && promo.extras.wifi_terms) {
            agg.extras.wifi_terms = promo.extras.wifi_terms;
        }
    }
    //console.log('agg',agg);
    return agg;
};

  const getCartItems = (session) => {
    const promo = getApplicablePromo(session, {
        speed: session.speed,
        pods: session.pods,
        groupId: session.promoGroupID ?? null
    });

    let cartItems = [];
    let runningSubtotal = 0;

    const _add = (name, amount, discount = false) => {
        cartItems.push({ name, amount, discount });
        runningSubtotal += parseFloat(amount);
    };

    if (!session.availableServices) return cartItems;

    // Internet
    for (const speed of session.availableServices.internet) {
        if (speed.download === session.speed) {
            _add(speed.ddisplay, speed.amount);
            break;
        }
    }

    // Wi-Fi
    let podPromo = false;
    if (session.pods !== '0') {
        let promoPodPrice = 12;
        let firstPodPrice = 7;

        if (promo?.discount?.pods_included) {
            let numPromoPods = Math.min(promo.discount.pods_included, parseInt(session.pods));
            promoPodPrice = 7;
            podPromo = [`${numPromoPods} Smart Wi-Fi`, -1 * promoPodPrice];
        }

        const podPrice = parseInt(session.pods) > 1
            ? firstPodPrice + (parseInt(session.pods) - 1) * 5
            : firstPodPrice;

        _add(`${session.pods} Smart Wifi`, podPrice);
    }

    // Phone
    if (session.phone) {
        const phoneService = session.availableServices.phone[0];
        _add(phoneService.description, parseFloat(phoneService.amount));

        if (session.battery) {
            _add('Battery Backup', parseFloat(phoneService.battery_amount));
        }
    }

    // Promos
    if (promo) {
        promo.allPromos.forEach(p => {
            for (const itemKey in p.discount) {
                if (itemKey !== 'pods_included' && itemKey !== 'free' && p.display) {
                    const isPercentage = p.discount.percentage !== undefined;
                    const discountAmount = isPercentage
                        ? -1 * (runningSubtotal * (parseFloat(p.discount.percentage) / 100))
                        : -1 * parseFloat(p.discount[itemKey] || 0);

                    _add(p.description, discountAmount, true);
                }
            }
        });
    }

    if (promo?.discount?.free && session.pods > 0) {
        _add(promo.discount.free, -7.00, true);
    }

    // Promo Code
    if (session.promoCode !== '') {
        let promoCodeAmount = parseFloat(session.promoCodeAmount || 0);
        const promoCodePercent = parseFloat(session.promoCodePercent || 0);

        if (promoCodePercent > 0) {
            promoCodeAmount = -1 * (runningSubtotal * (promoCodePercent / 100));
        }

        _add(session.promoCodeName, promoCodeAmount, true);
    }

    return cartItems;
};


const getSubtotal = (session) => {
    //console.log('Session:', session);
    if (!session || !session.availableServices) return 0;
    /*console.log('Session:', session);
    console.log('Selected Speed:', session.speed);
    console.log('Promo Group ID:', session.promoGroupID);
    console.log('Pods:', session.pods);
    console.log('Page:', session.page);
*/
    const promo = getApplicablePromo(session, {
        speed: session.speed,
        pods: session.pods,
        groupId: session.promoGroupID ?? null
    });
    //console.log('getsub after promo');
    //console.log('Applicable promo:', promo);

    let total = 0;
    const _calc = () => total < 0 ? "0.00" : (Math.round(total * 100) / 100).toFixed(2);

    const pagesToHideSubtotal = [
        'intro', 'address-unavailable', 'address-available',
        'presale', 'presale-notify', 'presale-notify-complete'
    ];

    if (!session.availableServices || pagesToHideSubtotal.includes(session.page)) return 0;

    for (const speed of session.availableServices.internet) {
        if (speed.download === session.speed) {
            total += parseFloat(speed.amount);
            break;
        }
    }

    if (promo) {
        for (const itemKey in promo.discount) {
            if (itemKey !== 'pods_included' && itemKey !== 'free') {
                //console.log(`- ${itemKey}: -$${promo.discount[itemKey]}`);
                total -= parseFloat(promo.discount[itemKey]);
            }
        }

        if (promo.discount.percentage > 0) {
            for (const p of promo.allPromos) {
                if (p.discount.percentage) {
                    const percentageDiscount = (total * parseFloat(p.discount.percentage)) / 100;
                    //console.log(`- ${p.description}: ${p.discount.percentage}% = -$${percentageDiscount.toFixed(2)}`);
                    total -= percentageDiscount;
                }
            }
        }
    }

    if (session.page === 'choose-internet') return _calc();

    let podCount = session.page === 'choose-internet' ? 0 : parseInt(session.pods);
    let firstPodPrice = 7;
    let secondPodPrice = 5;

    if (promo?.discount?.free && podCount > 0) {
        firstPodPrice = 0;
    }

    switch (podCount) {
        case 1: total += firstPodPrice; break;
        case 2: total += firstPodPrice + secondPodPrice; break;
        case 3: total += firstPodPrice + secondPodPrice + 5; break;
        case 4: total += firstPodPrice + secondPodPrice + 10; break;
    }

    if (session.page === 'choose-wifi') return _calc();

    if (!['choose-internet', 'choose-wifi'].includes(session.page) && session.phone) {
        const phoneService = session.availableServices.phone[0];
        total += parseFloat(phoneService.amount);

        if (session.battery) {
            total += parseFloat(phoneService.battery_amount);
        }
    }

    if (session.page === 'choose-phone') return _calc();

    

    if (session.promoCode !== '') {
        let promoCodeAmount = parseFloat(session.promoCodeAmount || 0);
        const promoCodePercent = parseFloat(session.promoCodePercent || 0);

        if (promoCodePercent > 0) {
            promoCodeAmount = -1 * (total * (promoCodePercent / 100));
        }

        total += promoCodeAmount;
    }

    return _calc();
};

const flattenSpeedsFromSession = (session) => {
    const groupID = session.promoGroupID?.toString() ?? null;
    const tiers = session.availableServices?.internet || [];
  
    return tiers
      .map(tier => tier?.[groupID])
      .filter(Boolean);
  };
  


function useCalculators() {
    const {actions, state/*, sendState*/} = useStateMachineWrapper();

    // legacy wrappers
    // todo: refactor these to just use the direct method
    const sessionWithFlattenedInternet = {
        ...state.session,
        availableServices: {
          ...state.session.availableServices,
          internet: flattenSpeedsFromSession(state.session),
        },
      };
      
      const _getApplicablePromo = (args) => getApplicablePromo(sessionWithFlattenedInternet, args || {});
      const _getCartItems = () => getCartItems(sessionWithFlattenedInternet);
      const _getSubtotal = () => getSubtotal(sessionWithFlattenedInternet);

    return {
        getApplicablePromo: _getApplicablePromo,
        getCartItems: _getCartItems,
        getSubtotal: _getSubtotal,
    };
}

export default useCalculators;

export {
    getApplicablePromo,
    getCartItems,
    getSubtotal,
};